import { IHeaderParams } from "ag-grid-community";
import React from "react";

import { IgAnalyticsTooltip, IgTypography } from "@intelligems/ig-theme";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";

export const ProfitAndLossHeaderRenderer = (props: IHeaderParams) => {
  const theme = useTheme();
  return (
    <Grid
      sx={{
        "& .ag-header-cell-comp-wrapper": {
          justifyContent: "end",
        },
      }}
      container
      direction={"row"}
      justifyContent={"end"}
    >
      <IgAnalyticsTooltip title={props.displayName}>
        <IgTypography
          fontWeight={600}
          sx={{ color: theme.igPrimitives.gray["A300"] }}
        >
          {props.displayName}
        </IgTypography>
      </IgAnalyticsTooltip>
    </Grid>
  );
};
